<template>
    <div class="row">
        <h2>{{shop.name}} users</h2>
        <div class='col-6'>
            <users-table ref="table"
                :dataTable="shopUsers"
                :tableFields="shopsUsersTableFileds"
                :defaultSortOrder="[sortOrder]">
                 <template slot="actions" slot-scope="props">
                        <button v-for="(name, index) in buttonTypes"
                            @click="removeUserFromShop(props.data.id)"
                            :key="index" class="btn btn-xs btn-info">
                            {{name.name}}
                         </button>
                </template>
            </users-table>
        </div>
        <div class='col-6'>
            <multiselect
                v-model="usersToAdd"
                trackBy="id" v-if="availableUsers.length > 0"
                :show-labels="false"
                :close-on-select="false"
                :hide-selected="true"
                :preserve-search="true"
                :custom-label="customLabel"
                :multiple="true"
                placeholder="User to add"
                :options="availableUsers">
                <template slot="tag" slot-scope="props">
                    <span class="custom__tag">
                        <span>{{props.option.name}}</span>
                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                    </span>
                </template>
            </multiselect>
            <div v-else>
                <p class="text-center">{{$t('REGISTRATION.noUser')}}</p>
            </div>
            <button v-if="availableUsers.length > 0" @click="saveUser" class="btn btn-cph-rounded btn-success d-block">Save</button>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import objectPath from 'object-path';
import Table from '../Table/Table';
import ShopsUsersTableFileds from '../../../utilities/tablesProperties/ShopsUsersTableFileds';

export default {
    name: 'shops-users',
    data () {
        return {
            shop: {},
            shopUsers: [],
            usersToAdd: null,
            shopsUsersTableFileds: ShopsUsersTableFileds,
            buttonTypes: [{
                name: 'removeUser'
            }],
            sortOrder: {
                field: 'name',
                direction: 'asc'
            }
        };
    },
    components: {
        'users-table': Table
    },
    created () {
        this.getShopUsers();
        this.GetAllUsers();
    },
    computed: {
        ...mapGetters({
            users : 'getUsers',
            user: 'getUser'
        }),
        userIds () {
            let result = [];
            let {resultArray: userIds} = this.$utils.getNestedKeyPaths(this.users, 'id');
            userIds.forEach(user => {
                if(!user.path.includes('shops')) {
                    user.path.pop();
                    let extractedUser = objectPath.get(this.users, user.path);
                    if(extractedUser) {
                        let {id, person:{firstName, lastName}} = extractedUser;
                        result.push({id, name: `${firstName} ${lastName}`});
                    }
                }
            });
            return result;
        },
        availableUsers () {
            return this.shop.users ?
                this.userIds.filter(({id}) => !this.shop.users.find(user => user.id === id))
                : this.userIds;
        }
    },
    methods: {
        ...mapActions([
            'GetShopById',
            'GetUser',
            'AddShopToUser',
            'addUserToShop',
            'GetShopFromUser',
            'deleteUserFromShop',
            'GetAllUsers'
        ]),
        ...mapMutations(['updateUserShopList', 'updateShop']),
        customLabel (value) {
            return `${value.name}`;
        },
        async getShopUsers () {
            let newShopUsers = [];
            await this.GetShopById(this.$route.params.id)
                .then(shop => this.shop = shop)
                .then(shop => shop.users.forEach(({id}) => 
                    this.GetUser(id).then(user => newShopUsers.push(user))));
            this.shopUsers = newShopUsers;
        },
        async saveUser () {
            await this.$utils.resolvePromises(this.usersToAdd.map(user => this.AddShopToUser({user: user, shop: this.shop})));
            await this.addUserToShop({shopId: this.shop.id, userIds: this.usersToAdd.map(user => ({id: user.id}))});
            let {data: shops} = await this.GetShopFromUser({id: this.user.id});
            this.updateUserShopList(shops);
            this.shop = await this.GetShopById(this.shop.id);
            this.updateShop(this.shop);
            this.usersToAdd = null;
            this.showModal = false;
            await this.getShopUsers();
        },
        async removeUserFromShop (id) {
            await this.deleteUserFromShop({shopId: this.shop.id, userId: id}).then(() => {
                this.getShopUsers();
            });
        }
    }
};
</script>

<style lang="scss" scoped>
    h2 {
        width: 100%;
        padding-left: 15px;
    }
    button {
        .removeUser::before { 
            content: "\E955";
        }
    }
</style>
